var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSuporte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3235_17169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3574 3.55078C6.22192 3.55078 2.85742 6.91528 2.85742 11.0508V14.158C2.85742 14.926 3.53017 15.5508 4.35742 15.5508H5.10742C5.30633 15.5508 5.4971 15.4718 5.63775 15.3311C5.7784 15.1905 5.85742 14.9997 5.85742 14.8008V10.9435C5.85742 10.7446 5.7784 10.5539 5.63775 10.4132C5.4971 10.2725 5.30633 10.1935 5.10742 10.1935H4.42642C4.84342 7.29103 7.34092 5.05078 10.3574 5.05078C13.3739 5.05078 15.8714 7.29103 16.2884 10.1935H15.6074C15.4085 10.1935 15.2177 10.2725 15.0771 10.4132C14.9364 10.5539 14.8574 10.7446 14.8574 10.9435V15.5508C14.8574 16.378 14.1847 17.0508 13.3574 17.0508H11.8574V16.3008H8.85742V18.5508H13.3574C15.0119 18.5508 16.3574 17.2053 16.3574 15.5508C17.1847 15.5508 17.8574 14.926 17.8574 14.158V11.0508C17.8574 6.91528 14.4929 3.55078 10.3574 3.55078Z",
    fill: "#6796CF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3235_17169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0 0.439453)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuporte);
export default __webpack_public_path__ + "static/media/IconSuporte.e09247e856498d25db4acbe4f66257af.svg";
export { ForwardRef as ReactComponent };